<template>
  <svg aria-hidden="true" ...attributes xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 2000 2000">
    <g>
      <path
        d="M2000.2-.3v1600h-400V399.7h-1000c-110.4,0-200,89.5-200,200v400c0,331.4,268.6,600,600,600h600v400h-600C448,1999.8.2,1552,.2,999.8V399.7h200c110.5,0,200-89.5,200-200V-.3h1600Z"
      />
    </g>
  </svg>
</template>
